import { ReactNode, createContext, useContext } from "react";
import { useTransactionStep } from "./transaction-step.hook";

const TransactionStepContext = createContext(
  {} as ReturnType<typeof useTransactionStep>
);
export function useTransactionStepContext() {
  return useContext(TransactionStepContext);
}

interface TransactionStepProviderProps {
  children: ReactNode;
}
export function TransactionStepProvider({ children }: TransactionStepProviderProps) {
  return (
    <TransactionStepContext.Provider value={useTransactionStep()}>
      {children}
    </TransactionStepContext.Provider>
  );
}
